import React from 'react';
import Modal from '../../component/Inc/Modal';
import MonthlySchedule from '../../component/teacher/MonthlySchedule';
function PopMonthlySchedule(props) {
  const {open, close} = props;
  return (
    <>
      <Modal open={open} close={close} type="pop_schedule_management" popSize="xl">
        <h2 className="pop_tit line">교사 월간 수업 스케줄</h2>
        <div className="content_container scroll">
          <MonthlySchedule />
        </div>
      </Modal>
    </>
  );
}

export default PopMonthlySchedule;
